import { ReactNode } from 'react'
import { Card, Button, Image, CardColors, Separator } from '@/ui'
import { Tooltip } from '@/features/taxes/quarterly/components/Tooltip'

export const SetupCard = ({
  children,
  continueDisabled = false,
  onBackClick,
  onContinueClick,
  onSkipClick,
  showSkipButton = true,
  isSkipForNow = false,
  completeButtonContent,
  continueDisabledMessage,
  step,
}: {
  currentStep: number
  children?: ReactNode
  continueDisabled?: boolean
  onBackClick?: () => void
  onContinueClick?: () => void
  onSkipClick?: () => void
  showSkipButton?: boolean
  isSkipForNow?: boolean
  completeButtonContent?: string
  continueDisabledMessage?: string
  step?: string
}) => {
  const skipText = isSkipForNow ? 'Skip For Now' : 'Skip'

  return (
    <Card color={CardColors.LEVEL_0_NO_BORDER}>
      <div className="flex flex-col space-y-4">
        <div className="flex flex-row items-start gap-4 px-8 pt-12 pb-4">
          {step === 'noLbaIntro' ? (
            <Image
              src="https://heard-images.s3.amazonaws.com/assets/upload-document.svg"
              alt="books"
              width={80}
              height={80}
              objectFit="scaleDown"
            />
          ) : (
            <Image
              src="https://heard-images.s3.amazonaws.com/assets/books_shadow.svg"
              alt="books"
              width={80}
              height={80}
              objectFit="scaleDown"
            />
          )}
        </div>

        <div className="px-8 pt-2 pb-6">{children}</div>

        <Separator />

        <div className="flex flex-wrap items-center justify-between px-8 py-6 gap-4">
          <div className="flex-grow">
            {onBackClick && (
              <Button variant="link" onClick={onBackClick}>
                Back
              </Button>
            )}
          </div>

          <div className="flex gap-3 items-center">
            {showSkipButton && onSkipClick && (
              <Button variant="secondary" onClick={onSkipClick}>
                {skipText}
              </Button>
            )}

            {onContinueClick &&
              (continueDisabled ? (
                <Tooltip
                  popup={{
                    body: continueDisabledMessage || 'Complete disabled',
                  }}
                  labelComponent={
                    <Button disabled size="lg">
                      {completeButtonContent || 'Complete'}
                    </Button>
                  }
                />
              ) : (
                <Button onClick={onContinueClick} size="lg">
                  {completeButtonContent || 'Complete'}
                </Button>
              ))}
          </div>
        </div>
      </div>
    </Card>
  )
}
